module.exports = __webpack_public_path__ + "054490c753e963c724bad67855921f90.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/ops_expert.png
 ** module id = 1069
 ** module chunks = 0
 **/